export default () => ({
  expanded: null,
  init() {},
});
